export default __webpack_public_path__ + "static/media/main_logo.f310993b.svg";